
import { Component, Emit, Vue } from 'nuxt-property-decorator'
import { IconSealPercent, IconStar, IconTicket, IconTrophy } from './icons'
import { AlButton } from '~/components/ui'

@Component({
  components: {
    AlButton,
    IconSealPercent,
    IconTicket,
    IconStar,
    IconTrophy,
  },
})
export default class BPHeader extends Vue {
  get benefitsList () {
    return [
      {
        icon: IconSealPercent,
        text: this.$t('blackSeptember.header.benefits.benefit1'),
      },
      {
        icon: IconTicket,
        text: this.$t('blackSeptember.header.benefits.benefit2'),
      },
      {
        icon: IconStar,
        text: this.$t('blackSeptember.header.benefits.benefit3'),
      },
      {
        icon: IconTrophy,
        text: this.$t('blackSeptember.header.benefits.benefit4'),
      },
    ]
  }

  get pictures () {
    return [
      require('~/assets/images/promos/black-september/black-september-header-man.webp'),
      require('~/assets/images/promos/black-september/black-september-header-man@2x.webp'),
    ]
  }

  get srcsetStr () {
    return `${this.pictures[0]} 1x, ${this.pictures[1]} 2x`
  }

  @Emit('cta-click')
  onCTAClick () {
    return undefined
  }
}
